import { useEffect, useState } from "react";
import { useContext } from "react";

import { IColumn } from "../../../manager/components/data-table/data-table";
import DataTable from "../../../manager/components/data-table/data-table";
import SimpleModal from "../../../shared/components/simple-modal/simple-modal";
import AuthContext from "../../../shared/context/auth-context";

interface ISelectUserModalProps {
  selectedIds: string[];
  show: boolean;
  onClosed: () => void;
  onSubmit: (selectedUserIds: string[]) => void;
}

const columns: IColumn[] = [
  {
    key: "name",
    displayName: "First Name",
    dataType: {
      type: "text",
    },
    sortable: false
  },
  {
    key: "last_name",
    displayName: "Last Name",
    dataType: {
      type: "text",
    },
    sortable: false
  },
  {
    key: "email",
    displayName: "Email Address",
    dataType: {
      type: "text",
    },
    sortable: false
  }
];

const SelectUserModal = ({show, selectedIds, onClosed, onSubmit}: ISelectUserModalProps) => {
  const authCtx = useContext(AuthContext);
  const [showModal, setShowModal] = useState(show);
  const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  const renderModalBody = () => {
    return (
      <div className="selectUserModal">
        <DataTable
          defaultSortCol="email"
          columns={columns}
          dataUrl={{
            url: `tenant/${authCtx.selectedTenant.selected_tenant_id}/users`,
            backend: "platform"
          }}
          isRowClickable={false}
          selectionMode="multi"
          preSelectedIds={selectedIds}
          onSelectionChange={setSelectedUserIds}
        />
      </div>
    );
  };

  const handleOnSubmit= () => {
    onSubmit(selectedUserIds);
    setShowModal(false);
  };
  
  return (
    <SimpleModal 
      show={showModal} 
      handleModalClosed={onClosed} 
      handleSubmit={handleOnSubmit} 
      mode="Add users to group"
      buttonText="Add"
      modalBody={renderModalBody()}
    />
  );
};

export default SelectUserModal;
